import { IStatusProps, Status, StatusType } from '@serodigital/ui-components';
import * as React from 'react';
import { DataPacketModal } from '../../../components/modal/dataPacketModal';

interface IPeripheralStatusProps extends Omit<IStatusProps, 'statusLabels'> {
  canViewData: boolean;
  peripheralData?: JSON;
}

const statusLabels = {
  success: 'Connected',
  waiting: 'Waiting on response',
  failed: 'Responded with error',
  offline: 'Offline',
  onlineWithDataPointCheckError: 'Online - Some Peripherals Not In Range',
};

export function PeripheralStatus(props: IPeripheralStatusProps) {
  if (!props.canViewData)
    return (
      <span data-qa={`peripheral-state-span-${props.label}`} className="relative">
        <Status {...props} statusLabels={statusLabels} />
      </span>
    );

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <span data-qa={`peripheral-state-span-${props.label}`} className="relative">
      <Status {...props} statusLabels={statusLabels} />
      {props.type === ('offline' as StatusType) && null}
      <DataPacketModal
        isOpen={isModalOpen}
        title={`${props.label}`}
        handleCloseModal={handleCloseModal}
        peripheralData={props.peripheralData}
      />
    </span>
  );
}
